// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"backToTop_backToTop__1K8_M"};